import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteHeader } from "@/components/layout/SiteHeader";
import { SiteFooter } from "@/components/layout/SiteFooter";
import { Hero } from "@/components/sections/Hero";
import { WhyAPN } from "@/components/sections/WhyAPN";
import { InterludeOne } from "@/components/sections/Interludes";
import { WhoWeHelp } from "@/components/sections/WhoWeHelp";
import { LearningPath } from "@/components/sections/LearningPath";
import { WaysWeHelp } from "@/components/sections/WaysWeHelp";
import { Programs } from "@/components/sections/Programs";
import { Membership } from "@/components/sections/Membership";
import { FAQ } from "@/components/sections/FAQ";
import { FinalCTA } from "@/components/sections/ConsultationForm";
import LegalPage from "@/pages/LegalPage";

const LandingPage = () => {
  return (
    <div className="App bg-background text-foreground">
      <SiteHeader />
      <main>
        <Hero />
        <WhyAPN />
        <InterludeOne />
        <WhoWeHelp />
        <LearningPath />
        <WaysWeHelp />
        <Programs />
        <Membership />
        <FAQ />
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
        <Route path="/terms-of-service" element={<LegalPage type="terms" />} />
        <Route path="/cookie-preferences" element={<LegalPage type="cookies" />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
